export default "__VITE_ASSET__D17FmGBH__"